import { Link } from 'react-router-dom';
import React, { Component } from 'react'; 
class Crucigrama extends Component{ 
    componentDidMount(){
    window.startx();
  }
    render(){ 
        return (
          <div id="main" className="wrapper style1">
            <div className="container">
              <header className="major">
                <h2>Crucigrama de los Dinosaurios</h2>
              </header>
             <span className="containerjuego">
          <div className="content">
            <div>
            <h2>
           
            </h2>
            </div>
          <iframe allow="fullscreen; autoplay; allow-top-navigation-by-user-activation" width="1080" height="720"  src="https://www.educaplay.com/game/15690923-crucigrama_de_los_dinosaurios.html" title='Crucigrama'></iframe>
          </div>
          <div className="containerjuego">
               <Link className="button" to="/juego">
                Regresar
              </Link>
            </div>
            </span>
            </div>
          </div>

          );
    } 
} 

export default Crucigrama;